import { createAsyncThunk } from '@reduxjs/toolkit';
import CommerceApiFetchWrapper from '../Utils/CommerceApiFetchWrapper.js';
import { trackSelection } from '../../../../Feature/Checkout/code/Views/Feature/Checkout/React/Thunks/AnalyticsThunks.jsx';
import { addMessage } from '../../../../Feature/Checkout/code/Views/Feature/Checkout/React/Slices/ShippingSlice.jsx';

export const updateExternalShippingMethod = createAsyncThunk(
  'updateExternalShippingMethod',
  async (reset = false, { getState, dispatch, rejectWithValue }) => {
    let state = getState();

    let externalShippingMethod = reset ? '' : state.Shipping.selectedExternalShippingMethod;
    const nshiftOptionsData = state.Shipping.nshiftOptionsData;
    const resultOptions = nshiftOptionsData?.result;
    const storeOptions = nshiftOptionsData?.storeOptions;
    const nonStoreOptions = nshiftOptionsData?.nonStoreOptions;
    const cart = state.Cart;

    let deliveries =
      externalShippingMethod?.subShipments?.map((subShipment) => {
        const isStore = subShipment.additionalValues?.isStore === 'true';
        const splitSourceOptions = isStore ? storeOptions : nonStoreOptions;

        const sourceOptions = resultOptions || splitSourceOptions;

        const lineIds =
          sourceOptions?.subShipmentToLinesMapping?.find(
            (mapping) => mapping.subShipmentId === subShipment.subShipmentId
          )?.lineIds || [];
        let selectedOption = sourceOptions?.optionsData?.subShipments
          ?.find((shipment) => shipment.subShipmentId === subShipment.subShipmentId)
          ?.options?.find((option) => option.optionId === subShipment.optionId);
        let text1 = selectedOption?.texts[0];

        let storeAddress = null;
        let pickUpPointName = null;
        if (subShipment.additionalValues?.isStore === 'true') {
          let pickupPoints = selectedOption?.pickupPoints;
          if (pickupPoints && pickupPoints.length > 0) {
            let pickupPoint = pickupPoints.find((p) => p.pickupPointId === subShipment.pickupPointId);
            if (pickupPoint) {
              storeAddress = {
                name: pickupPoint.name,
                address: pickupPoint.address1,
                postalCode: pickupPoint.postalCode,
                city: pickupPoint.city,
                phone: pickupPoint.phone,
              };

              pickUpPointName = pickupPoint.name;
            }
          }
        }

        return {
          shippingMethodId: subShipment.optionId,
          shippingMethodName: pickUpPointName ?? subShipment.optionTitle,
          pickupPointId: subShipment.pickupPointId,
          erpShippingMethodId: subShipment.additionalValues?.erpShippingMethodId,
          isHomeDelivery: subShipment.additionalValues?.isHomeDelivery === 'true',
          price: subShipment.totalPrice,
          estimatedDelivery: text1,
          storeAddress: storeAddress ? JSON.stringify(storeAddress) : null,
          lineItems: lineIds.map((lineId) => {
            return {
              id: lineId,
              quantity: cart?.lineItems?.find((item) => item.id === lineId)?.quantity || 0,
            };
          }),
        };
      }) ?? [];

    let payload = {
      Deliveries: deliveries,
    };

    let result = await CommerceApiFetchWrapper('/cart/external-shipping-methods', {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    if (!result) {
      window.scrollTo(0, 0);

      dispatch(
        addMessage({
          id: new Date().valueOf() * Math.random(),
          content: window._THULEDATA._Cart.generalErrorMessage,
          type: 'error',
        })
      );
      return rejectWithValue('updateExternalShippingMethod failed');
    }

    // GA/SET_SHIPPING_METHOD;
    dispatch(trackSelection());

    return result;
  }
);

export const updateShippingMethod = createAsyncThunk(
  'updateShippingMethod',
  async (reset = false, { getState, dispatch }) => {
    let state = getState();

    let selectedMethodId = reset ? '' : state.Shipping.selectedShippingMethod;

    const body = JSON.stringify({
      ShippingMethodId: selectedMethodId,
    });

    let result = await CommerceApiFetchWrapper('/cart/shipping-method', {
      method: 'POST',
      body: body,
    });

    if (!result) {
      window.scrollTo(0, 0);

      dispatch(
        addMessage({
          id: new Date().valueOf() * Math.random(),
          content: window._THULEDATA._Cart.generalErrorMessage,
          type: 'error',
        })
      );
      return rejectWithValue('setShippingMethod failed');
    }

    // GA/SET_SHIPPING_METHOD;
    dispatch(trackSelection());

    return result;
  }
);

export const setEstimatedShippingOnCart = async () => {
  let result = await CommerceApiFetchWrapper('/cart/estimated-shipping', {
    method: 'GET',
  });

  return result;
};

export const getPrice = (method, subtotal, hasNewsletterSubscription = false) => {
  const marketCountryCode = _THULEDATA.SitecoreLanguage?.split('-')[1];
  const isExcludedMarket = ['US', 'CA'].indexOf(marketCountryCode) > -1;

  if (
    (window._THULEDATA._Cart.freeFreightEnabled && !isExcludedMarket && hasNewsletterSubscription) ||
    (window._THULEDATA._Cart.freeFreightEnabled && window._THULEDATA._siteHeader?.IsLoggedIn) ||
    (method.freeAbove && subtotal > method.freeAbove)
  ) {
    return 0;
  }
  return method.price;
};
